import React from 'react';
import { Card } from 'react-bootstrap';

function TotalCtoCost({ totalCTOcost }) {
    const numberWithCommas = (number) => {
        return number?.toLocaleString() || 0;
    };

    const formattedTotalAmount = numberWithCommas(totalCTOcost);

    return (
        <Card className="text-center totalCtoCostContainer">
            <Card.Body className="totalCtoCostBody">
                <Card.Title className="totalCtoCostTitle">Total CTO Cost:</Card.Title>
                <Card.Text className="totalCtoCost">
                    ₹{formattedTotalAmount}
                </Card.Text>
            </Card.Body>
        </Card>
    );
}

export default TotalCtoCost;